import { LifecycleEvent } from 'apprise-core/common'
import { Tag, tagLifecycleTopic } from 'apprise-core/tag'
import { EventSubscription } from "apprise-frontend-events/subscriptions"
import { useCurrentLocation } from 'apprise-ui/link/currentlocation'
import { useHistory } from 'react-router-dom'
import { useTagStore } from './store'




// supports first generation or second generation publishers.
export const useTagLifecycleListener = (): EventSubscription<LifecycleEvent<Tag>> => {

    const store = useTagStore()

    const location = useCurrentLocation()

    const history = useHistory()
   
    return {

        topic: tagLifecycleTopic

        ,

        onEvent: (event: LifecycleEvent<Tag>) => {

            // updates local cache.
            store.push(event)

            // sends signal to subscribers mounted on impacted routes, so they can warn the user.
            history.replace(location.current(), `${event.subject.id}-${event.type}`)
                

        }

    }

}